import { Clickable } from '@routable/gross-ds';
import React from 'react';

import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';

import { CustomerServiceHelper } from 'modules/customerSupport';

/**
 * Default error message that displays in the ServerAlert swal.
 * @return {StatelessComponent}
 */
const ServerErrorDefaultMessage = () => (
  <span className="alert-error-text">
    Please contact{' '}
    <Clickable onClick={() => CustomerServiceHelper.show()}>{PLATFORM_DISPLAY_SHORT_NAME} support</Clickable> and
    we&apos;ll be happy to assist.
  </span>
);

export default ServerErrorDefaultMessage;
